// extracted by mini-css-extract-plugin
export default {"sessionName":"DashboardGoalSummaryCard_sessionName__egcQt"};